import React, { useContext } from 'react';
import { Drawer, useMediaQuery } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { alpha } from '@mui/material/styles';
import { MenuContext } from '../../context/Menu';
import Logo from './Logo';
import Menu from './Menu';

const MenuContainer = styled('div')(`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
`);

const SidebarContainer = styled('div')(({ theme }) => ({
  backgroundColor: alpha(theme.palette.secondary.main, 0.04),
  border: `1px solid ${alpha(theme.palette.secondary.main, 0.06)}`,
  height: '100%',
  width: '100%',
  borderRadius: '16px',
  overflow: 'hidden',
}));

function Sidebar() {
  const { menuWidth } = useContext(MenuContext);
  return (
    <SidebarContainer style={{ width: `${menuWidth}px` }}>
      <MenuContainer>
        {/* <MenuCurveShapeContainer>
          <MenuCurveShapeBox />
        </MenuCurveShapeContainer> */}
        <div className="w-full">
          <Logo />
          <Menu />
        </div>
      </MenuContainer>
    </SidebarContainer>
  );
}

function ResponsiveSidebar() {
  const theme = useTheme();
  const renderMobileMenu = useMediaQuery(theme.breakpoints.down('md'));
  const { menuWidth, showMobileMenu, setShowMobileMenu } = useContext(MenuContext);
  const onClose = function () {
    setShowMobileMenu?.(false);
  };
  return (
    <>
      {renderMobileMenu && (
        <Drawer anchor={'left'} open={showMobileMenu} onClose={onClose}>
          <div style={{ width: `${menuWidth}px`, height: '100%' }}>
            <Sidebar />
          </div>
        </Drawer>
      )}
      {!renderMobileMenu && <Sidebar />}
    </>
  );
}

export default ResponsiveSidebar;
